import React, { createRef, useEffect, useState } from "react";
import AddRecord from "../Modals/AddRecord";
import FeedbackAlert from "./FeedbackAlert";
import MainDashboard from "./MainDashboard";
import SidebarNavigation from "./SidebarNavigation";

const Dashboard = () => {
  const [navigationWidth, setNavigationWidth] = useState(undefined);
  const navigation = createRef();

  useEffect(() => {
    setNavigationWidth(() => {
      return navigation?.current?.offsetWidth;
    });
  }, [navigation, navigationWidth]);

  return (
    <>
      <FeedbackAlert />
      <div className="w-full flex">
        {/**Sidebar navigation*/}
        <SidebarNavigation navigation={navigation} />

        {/**Main dashboard*/}
        <MainDashboard containerMaxWidth={navigationWidth} />

        <AddRecord />
      </div>
    </>
  );
};

export default Dashboard;
